export const SITECONFIG_QUERY_KEYS = {
  default: () => ['siteconfig'] as const,
  getShippingPolicies: () => [...SITECONFIG_QUERY_KEYS.default(), 'shippingPolicies'] as const,
};
